<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">
    <g id="ic_delete_close" transform="translate(-887 -208)">
      <rect id="bound" width="64" height="64" transform="translate(887 208)" fill="none" />
      <path
        id="path"
        d="M40.217,31.219,34.1,37.333l6.115,6.115a2.666,2.666,0,1,1-3.771,3.771L30.332,41.1l-6.115,6.115a2.666,2.666,0,0,1-3.771-3.771l6.115-6.115-6.115-6.115a2.666,2.666,0,0,1,3.771-3.771l6.115,6.115,6.115-6.115a2.666,2.666,0,0,1,3.771,3.771ZM59.665,13.333A2.666,2.666,0,0,1,57,16h-2.36l-3.4,35.925A13.281,13.281,0,0,1,37.961,64H22.689A13.281,13.281,0,0,1,9.417,51.944L5.961,16H3.668a2.667,2.667,0,1,1,0-5.333H14.6A13.358,13.358,0,0,1,27.668,0H33A13.356,13.356,0,0,1,46.065,10.667H57a2.666,2.666,0,0,1,2.667,2.667ZM20.124,10.667H40.54A8.012,8.012,0,0,0,33,5.333H27.665A8.012,8.012,0,0,0,20.124,10.667ZM49.281,16H11.318l3.408,35.432a7.966,7.966,0,0,0,7.963,7.235H37.961a7.968,7.968,0,0,0,7.965-7.248L49.281,16Z"
        transform="translate(888.999 208)"
        fill="currentColor" />
    </g>
  </svg>
</template>
